import { render, staticRenderFns } from "./common-problem2.vue?vue&type=template&id=17c2401b&scoped=true"
import script from "./common-problem2.vue?vue&type=script&lang=js"
export * from "./common-problem2.vue?vue&type=script&lang=js"
import style0 from "./common-problem2.vue?vue&type=style&index=0&id=17c2401b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c2401b",
  null
  
)

export default component.exports